import { BaseModel } from "@blue-chip/core";
import User from "./User";
import Project from "./Project";

export default class ProjectMemberUser extends BaseModel {
  static get belongsTo() {
    return [User, Project];
  }
}
